var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 82,
    viewBox: "0 0 125 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dynamic",
    d: "M102.548 13.1576C101.549 7.01588 105.695 1.19366 111.837 0.155167C118.008 -0.868922 123.818 3.28429 124.84 9.42069C125.879 15.5841 121.738 21.4017 115.57 22.4393C109.426 23.4643 103.609 19.3155 102.548 13.1576Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "dynamic",
    d: "M96.2334 30.3627C95.5976 30.3627 94.979 30.4133 94.3577 30.4576C97.8805 25.5511 100.332 19.7092 99.9242 13.1076C99.5503 7.58436 92.9932 3.47546 86.584 8.67348L86.4648 8.7692L1.94277 68.3161C-0.452097 70.2369 -0.669874 74.3316 1.49575 77.0316C3.67938 79.7363 7.8994 79.5132 9.77341 78.4386L71.3501 48.6154C70.6358 50.95 70.2448 53.4197 70.2448 55.9808C70.2448 70.1041 81.9054 81.5964 96.2371 81.5964C110.569 81.5964 122.23 70.1048 122.23 55.9808C122.228 41.8548 110.568 30.363 96.2348 30.363L96.2334 30.3627ZM96.2334 77.8093C83.9885 77.8093 74.0276 68.0164 74.0276 55.982C74.0276 50.2203 76.5445 45.9505 76.5526 45.9471L65.2487 30.7483L80.4068 19.4084L82.2842 21.9288L69.6205 31.4112L90.9522 59.4334C92.0656 60.8765 93.74 61.6332 95.4314 61.6332C96.637 61.6332 97.8526 61.2513 98.8803 60.4565C101.352 58.5493 101.812 55.001 99.9034 52.5284L88.2058 37.364C89.0565 36.5729 89.9018 35.7357 90.7237 34.8579C92.4892 34.4136 94.3298 34.1508 96.2352 34.1508C108.479 34.1508 118.44 43.9436 118.44 55.9827C118.439 68.0162 108.477 77.8091 96.2333 77.8091L96.2334 77.8093Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCore);
export default __webpack_public_path__ + "static/media/core.e971e1a3b790a44cf510b2a85edf3d17.svg";
export { ForwardRef as ReactComponent };